export default function imageRendererRule(tokens, idx) {
  var token = tokens[idx];
  var srcAttrIndex = token.attrIndex('src');
  var imgSrc = token.attrs[srcAttrIndex][1];
  var alt = token.content;

  // render a placeholder to render ImageViewer component
  return "<div class=\"hm-image-zoom\" data-src=\"".concat(imgSrc, "\"").concat(alt ? " data-alt=\"".concat(alt) : '', "\" /></div>");
}